import { NavLink } from "react-router-dom";
import { Building2, FileText, Flag, LayoutDashboard, Scale, Users, WalletCards, X } from "lucide-react";
import { IconButton, cn, focusRing } from "../../components/ui";

export const ADMIN_NAV_ITEMS = [
  { label: "Dashboard", path: "/admin/dashboard", icon: LayoutDashboard },
  { label: "Applications", path: "/admin/applications", icon: FileText },
  { label: "Businesses", path: "/admin/businesses", icon: Building2 },
  { label: "Commission Revenue", path: "/admin/commission-revenue", icon: WalletCards },
  { label: "Reports", path: "/admin/reports", icon: Flag },
  { label: "Appeals", path: "/admin/appeals", icon: Scale },
  { label: "Users", path: "/admin/users", icon: Users },
];

function linkClass({ isActive }) {
  return cn(
    "flex min-h-8 items-center gap-2.5 rounded-control px-2 text-body-sm transition-colors duration-150 max-md:min-h-touch",
    focusRing,
    isActive
      ? "bg-accent-subtle font-medium text-accent"
      : "text-secondary hover:bg-hover hover:text-foreground"
  );
}

export default function AdminSidebar({ onNavigate, onClose }) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex h-[var(--layout-topbar)] shrink-0 items-center gap-2 border-b border-subtle px-4">
        <div className="min-w-0 flex-1">
          <div className="truncate text-panel-title text-foreground">Admin Panel</div>
        </div>
        {onClose ? <IconButton icon={X} label="Close menu" size="sm" onClick={onClose} className="-mr-2" /> : null}
      </div>

      <nav className="flex min-h-0 flex-1 flex-col gap-px overflow-y-auto px-2 py-3 scrollbar-fade" aria-label="Admin navigation">
        {ADMIN_NAV_ITEMS.map(({ label, path, icon: Icon }) => (
          <NavLink key={path} to={path} className={linkClass} onClick={onNavigate}>
            {({ isActive }) => (
              <>
                <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
                <span className="truncate">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
